module.exports = __webpack_public_path__ + "resources/img/img_tcc_advantage3.5401a6e61076832519eeaf3311766ed1.jpg";